import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import TransactionRequests from "./pages/TransactionRequests";
import Settings from "./pages/Settings";
import Account from "./components/Account";
import Terms from "./components/Terms";
import PastTransactions from "./pages/PastTransactions";
import PendingRequests from "./pages/PendingRequests";
import ActiveUsers from "./pages/ActiveUsers";
import Principals from "./pages/Principals";

import { Buffer } from "buffer";

function App() {
  window.Buffer = window.Buffer || require("buffer").Buffer;

  return (
    <div className="App" id="app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TransactionRequests />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/account" element={<Account />} />
          <Route path="/termsandconditions" element={<Terms />} />
          <Route path="/pastTransactions" element={<PastTransactions />} />
          <Route
            path="/transactionRequests"
            element={<TransactionRequests />}
          />
          <Route path="/users" element={<ActiveUsers />} />
          <Route path="/pendingRequests" element={<PendingRequests />} />
          <Route path="/principals" element={<Principals />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
